import React from 'react';
import Container from '../../../containers/integration/modules/showModuleContainer';

export default function () {
  return (
    <Container />
  );
}
